import { ChangeDetectionStrategy, Component, DOCUMENT, inject } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Page } from '@core/services';

/**
 * Component that renders the section for downloading the mobile application.
 */
@Component({
  selector: 'app-section-download-app',
  imports: [LazyLoadImageModule],
  templateUrl: './section-download-app.component.html',
  styleUrl: './section-download-app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionDownloadApp {
  /**
   * Service for handling page data.
   */
  private readonly page = inject(Page);
  private readonly document = inject(DOCUMENT);

  /**
   * Signal containing the home page information.
   */
  protected readonly home = this.page.signalHome;

  /**
   * Opens the provided URL in a new browser tab.
   * @param url The URL to open.
   */
  protected goToUrl(url: string | undefined): void {
    if (!url) return;
    this.document.defaultView?.open(url, '_blank', 'noopener');
  }
}
